require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('../generic.view.ts');

var Handlebars = require('handlebars');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

var TicketRowTemplate = require('text-loader!../../templates/tickets/ticketRow.template.html');
var PaymentRowTemplate = require('text-loader!../../templates/tickets/paymentRow.template.html');

var TicketPopupTemplate = require('text-loader!../../templates/tickets/hasTicketPopup.template.html');
var PaymentPopupTemplate = require('text-loader!../../templates/tickets/hasOnlyPaymentPopup.template.html');

var i18n = require("l10n");

var TheView = GenericView.extend({
    tagName: 'tr',
    className: 'ticketRow ticketPaymentRow',
	ticketRowTemplate: Handlebars.compile(TicketRowTemplate),
	paymentRowTemplate: Handlebars.compile(PaymentRowTemplate),
	ticketPopupTemplate: Handlebars.compile(TicketPopupTemplate),
	PaymentPopupTemplate: Handlebars.compile(PaymentPopupTemplate),
	stompSubscriptions: null,
	initialize: function (options) {
		var self = this;

        this.model = options ? options.model : null;
        this.wsocket = options ? options.wsocket : null;
        this.client = options ? options.client : null;

		this.unsubscribeStomp();
        this.subscribeToStomp();

        $(window).off("tickets:closed").on("tickets:closed", function() {
            self.unsubscribeStomp();
        });
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();

		var template;

		if(this.model.number) {
		    template = this.ticketRowTemplate;
		}
		else {
		    template = this.paymentRowTemplate;
		}


		this.$el.html( template(this.model) );

		return this;
	},
	events: {
	    "click td": "showPopup"
	},
	unsubscribeStomp: function() {
        if(this.stompSubscriptions) {
            this.stompSubscriptions.unsubscribe();
            this.stompSubscriptions = null;
        }
    },
    subscribeToStomp: function() {
        if(this.stompSubscriptions != null) // already subscribed
            return;

        var self = this;

        this.stompSubscriptions = self.client.subscribe('/live/admin/tickets/' + this.model.id, function (message){
            var responseObject = JSON.parse( message.body );

            self.model = responseObject;

            self.render();

            var $popup = $("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup");
            var id = parseInt( $($popup[0]).data("id") );

            // if it has an opened popup, reload it
            if( !isNaN(id) && $popup.parent().css("display") == "block" ) {
                self.closePopup();
                $(self.$el.find("td")[0]).trigger("click");
            }
        });
    },
    showPopup: function(e) {
        var isTicket = !isNaN(this.model.number);

        var $popupContainer = $("#ticketsPaymentsAppointmentsPopup");
        $popupContainer.empty();

        if(isTicket) {
            $popupContainer.html( this.ticketPopupTemplate(this.model)  );
        }
        else {
            $popupContainer.html( this.PaymentPopupTemplate(this.model)  );
        }

        var $popup = $popupContainer.find(".tpaPopup");

        $popupContainer.show();

        this.bindPopupEvents(isTicket, e);
    },
    bindPopupEvents: function(isTicket, e) {
        var self = this;

        this.lastClickedButton = $(e.currentTarget);

        if(isTicket) {
            $("#submitTicketChange").off("click").on("click", function() {
                var $btn = $(this);
                
                $btn.prop('disabled', true); // disable button, to avoid multiple clicks

                var ticketId = self.model.id;
                var ticketPriority = parseInt($("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup").find('.ticketPriority').val());
                var queueId = self.model.queueId;

                $.ajaxDefaultQ({
                    url: "rest/api/admin/ticket/priority?ticketId=" + ticketId + "&status="+ ticketPriority + "&queueId=" + queueId,
                    type: "POST",
                    contentType: "application/json",
                    data: {}
                }).done(function(response, status, xhr){

                    if(response && response.error == null) {

                        var text = "";
                        var className = "";

                        if(response.data == true || response.data && response.data.value == true) {
                            text = i18n.t("tickets.priorityChangedSuccessfully");
                            className = "success";
                        }
                        else if(response.data == false || response.data && response.data.value == false) {
                            text = i18n.t("server.errorOccurred");
                            className = "error";

                            // revert selection
                            $btn.val($btn.data("last-value"));
                        }
                        else {
                            text = i18n.t("server.errorOccurred");
                            className = "error";

                            // revert selection
                            $btn.val($btn.data("last-value"));
                        }

                        $btn.notify(text,
                        {
                            position: "top center",
                            className: className,
                            autoHide: true
                        });

                    }
                    else {
                        $btn.notify(i18n.t("server.errorOccurred"),
                        {
                            position:"top center",
                            className: "error",
                            autoHide: true
                        });

                        // revert selection
                        $btn.val($btn.data("last-value"));
                    }

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                })
                .fail(function(response) {
                    $btn.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                });
            });

            $("#submitTicketCancel").off("click").on("click", function() {
                if(!confirm(i18n.t('tickets.confirmCancellation')))
                    return;

                var $btn = $(this);

                $btn.prop('disabled', true); // disable button, to avoid multiple clicks

                var ticketId = self.model.id;
                var queueId = self.model.queueId;

                $.ajaxDefaultQ({
                    url: "rest/api/admin/ticket/cancel?ticketId=" + ticketId + "&queueId=" + queueId,
                    type: "POST",
                    contentType: "application/json",
                    data: {}
                }).done(function(response, status, xhr){

                    if(response && response.error == null) {

                        var text = "";
                        var className = "";

                        if(response.data == true || response.data && response.data.value == true) {
                            text = i18n.t("tickets.ticketCancelledSuccessfully");
                            className = "success";
                        }
                        else if(response.data == false || response.data && response.data.value == false) {
                            text = i18n.t("server.errorOccurred");
                            className = "error";

                            // revert selection
                            $btn.val($btn.data("last-value"));
                        }
                        else {
                            text = i18n.t("server.errorOccurred");
                            className = "error";

                            // revert selection
                            $btn.val($btn.data("last-value"));
                        }

                        $btn.notify(text,
                        {
                            position: "top center",
                            className: className,
                            autoHide: true
                        });

                    }
                    else {
                        $btn.notify(i18n.t("server.errorOccurred"),
                        {
                            position:"top center",
                            className: "error",
                            autoHide: true
                        });

                        // revert selection
                        $btn.val($btn.data("last-value"));
                    }

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                })
                .fail(function(response) {
                    $btn.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                });
            });
        }
        else { // isPayment
            $("#submitTicketIssue").off("click").on("click", function() {
                var $btn = $(this);

                $btn.prop('disabled', true); // disable button, to avoid multiple clicks

                var ticketId = self.model.id;
                var queueId = self.model.queueId;

                $.ajaxDefaultQ({
                    url: "rest/api/admin/ticket/issueAppointmentTicket?paymentId=" + self.model.id,
                    type: "POST",
                    contentType: "application/json",
                    data: {}

                }).done(function(response, status, xhr){

                    if(response != null) {

                        var text = "";
                        var className = "";

                        if(response.error != null) {
                            text = i18n.t("server.errorOccurred");
                            className = "error";
                        }
                        else if(response.data == "Success") {
                            text = i18n.t('counter.issuedTicketSuccess');
                            className = "success";
                        }
                        else if(response.data == "QueueClosed") {
                            text = i18n.t("counter.queueClosed");
                            className = "info";
                        }
                        else if(response.data == "CustomerDailyLimit") {
                            text = i18n.t("counter.customerDailyLimit");
                            className = "info";
                        }
                        else if(response.data == "QueueDailyLimit") {
                            text = i18n.t("counter.queueDailyLimit");
                            className = "info";
                        }
                        else if(response.data == "CustomerAlreadyHasTicket") {
                            text = i18n.t("counter.customerAlreadyHasTicket");
                            className = "info";
                        }
                        else {
                            text = i18n.t("server.errorOccurred");
                            className = "error";
                        }

                        $btn.notify(text,
                        {
                            position: "top center",
                            className: className,
                            autoHide: true
                        });

                    }
                    else {
                        $btn.notify(i18n.t("server.errorOccurred"),
                        {
                            position: "top center",
                            className: "error",
                            autoHide: true
                        });

                    }

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                })
                .fail(function(response) {
                    $btn.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });

                    setTimeout(function() {
                        self.closePopup();
                        $btn.prop('disabled', false);
                    }, 2000);
                });
            });
        }

        // both cases
        $("#closeTicketPopup").off("click").on("click", function() {
            var $popup = $("#ticketsPaymentsAppointmentsPopup").find(".tpaPopup");
            $popup.parent().hide();
            $popup.empty();
        });
    },
    closePopup: function() {
        $("#closeTicketPopup").trigger("click");
    }
});

module.exports = TheView;